export default "__VITE_ASSET__DSVqdB5Z__"